<template>
  <p-dialog
    class="p-dialog-prompt"
    :title="title"
    :type="type"
    :has-close-button="false"
    v-on="$listeners"
    @close="close(null)"
    @closeOnEsc="close(null)"
  >
    <template #content>
      <p>{{ message }}</p>
      <p-text-field ref="textField" v-model="enteredValue" autofocus solo @keyup.enter="close(enteredValue)"></p-text-field>
    </template>
    <template #actions>
      <p-button secondary @click.prevent="close(null)">
        {{ $t('core.app.cancel') }}
      </p-button>
      <p-button @click.prevent="close(enteredValue)">
        {{ $t('core.app.ok') }}
      </p-button>
    </template>
  </p-dialog>
</template>

<script lang="ts">
  import Vue from 'vue';

  export default Vue.extend({
    props: {
      value: { type: String, default: '' },
      title: { type: String, default: undefined },
      message: { type: String, default: undefined },
      type: { type: String, default: 'base' },
    },
    data: () => ({
      enteredValue: '',
    }),
    mounted() {
      this.enteredValue = this.value;
      try {
        const textField = this.$refs.textField as Vue;
        const inputEl = textField.$refs.input as HTMLInputElement;
        inputEl.focus();
        this.$nextTick(() => {
          inputEl.setSelectionRange(0, inputEl.value.length);
        });
      } catch (error) {
        // not a critical error, just print to console
        this.$log.error(error);
      }
    },
    methods: {
      close(result?: string | null) {
        // Same behaviour as window.prompt
        this.$emit('input', result ?? null);
        this.$el.remove();
        this.$destroy();
      },
    },
  });
</script>
